import { render, staticRenderFns } from "./BlendDetails.vue?vue&type=template&id=62280fa5&scoped=true&"
import script from "./BlendDetails.vue?vue&type=script&lang=js&"
export * from "./BlendDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlendDetails.vue?vue&type=style&index=0&id=62280fa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62280fa5",
  null
  
)

export default component.exports